import { cva } from "cva";

export const headerStyles = cva({
  base: "w-full bg-surface shadow-sm sticky top-0 relative z-100",
});

export const headerContainerStyles = cva({
  base: "mds-container flex items-center justify-between gap-x-16 h-64",
});
